import { css, SxProps } from "@mui/material";

const scrollCss = css`
  &::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1); */
    /* background-color: #f5f5f5; */
    /* background-color: green; */
    border-radius: 8px;
    width: 50px;
  }

  &::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
    background-color: white;
    border-inline-color: white;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #dde1de;
    /* background-image: -webkit-gradient(linear, 40% 0%, 75% 84%, from(#4d9c41), to(#19911d), color-stop(0.6, #54de5d)); */
  }
`;

export const scrollBarSxStyles: SxProps = { "&": scrollCss.styles };
